import { TOUR_PRIVACY } from "./../../constants/TourPrivacy.const";

export const tourInitialState = { 
    info: {
        tourName: "",
        tourDescription: "",
        tourCity: "",
        tourCountry: "",
        latitude: "",
        longitude: "",
        tourPoster: {
            url: "",
            file: null
        }
    },
    privacy: TOUR_PRIVACY.UNLISTED,
    scenes: [],
    createdBy: {
     uid: "",
     name: "",
     email: "",
     at: "",
    },
    updatedBy: {
     uid: "",
     name: "",
     email: "",
     at: "", 
    }
    
  }
  
export const sceneInitialState = {
    name: "",
    description: "",
    audio: {
        url: "",
        file: null
    },
    panoImage: {
        url: "",
        file: null
    },
    pan: 90,
    tilt: 0,
    cameraFree: true,
    zoom: 1,
    hotspots: []
}

export const tourErrorInitialState = {
    info: {
        tourName: "", 
        tourDescription: "",
        tourCity: "",
        tourCountry: "",
        latitude: "",
        longitude: "",
        scene:""
    },
    scenes: []
}

export const sceneErrorInitialState = {
    name: "",
    description: "",
    hotspots: []
}

export const hotspotErrorInitialState = {
    name: "",
    description: ""
}


export const HOTSPOT_TYPES = {
    MOVE: "move",
    DATA: "data"
}

export const hotspotInitialState = {
    name: "",
    description: "",
    hotspotType: HOTSPOT_TYPES.DATA,
    sceneIndex: null,
    position: {
        x: 0,
        y: 0,
        z: 0
    },
    image: {
        url: "",
        file: null
    },
    video: {
        url: "",
        file: null
    },
    audio: {
        url: "",
        file: null
    },
}

export const userInitialState = {
    uid: "",
    name: "",
    email: "",

}
